const productsImageManip = "f_auto,q_auto";

const artists = [
  {
    id: "henryd",
    name: "Henryd",
    img: `https://res.cloudinary.com/habitatsartorial/image/upload/v1657588036/2022/Contracts/Henryd/Screen_Shot_2022-07-11_at_18.06.07_ytuwnq.png`,
    description: "Description 1",
    altLink: "",
    products: [
      {
        id: 20,
        price: 20,
        type: "Tank",
        img: `https://res.cloudinary.com/habitatsartorial/image/upload/${productsImageManip}/v1657588309/2022/Contracts/Henryd/Screen_Shot_2022-07-11_at_18.11.20_nnjmsi.png`,
        images: [
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1657588313/2022/Contracts/Henryd/Screen_Shot_2022-07-11_at_18.11.30_cglvh7.png",

          `https://res.cloudinary.com/habitatsartorial/image/upload/v1657588309/2022/Contracts/Henryd/Screen_Shot_2022-07-11_at_18.11.01_vv522b.png`,
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1657588033/2022/Contracts/Henryd/Screen_Shot_2022-07-11_at_18.06.28_xjre6n.png",
        ],
        description: [
          "'Where do I Go Next' logo across chest",
          "100% 6.1oz ringspun cotton",
          "Preshrunk, soft-washed, garment-dyed",
          "Color: Red",
        ],
        name: '"Where do I Go Next" Tank',
        disabled: false,
      },
    ],
  },
  {
    id: "bifi22",
    name: "By Indy, For Indy 2022",
    img: `https://res.cloudinary.com/habitatsartorial/image/upload/v1659380199/2022/bifi22/bifi22.001_qb1wzn.jpg`,
    description: "Description 1",
    altLink: "",
    products: [
      {
        id: 22,
        price: 23,
        type: "SS Tee",
        img: `https://res.cloudinary.com/habitatsartorial/image/upload/${productsImageManip}/v1659380276/2022/bifi22/icons.001_tkhg4b.jpg`,
        images: [
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380199/2022/bifi22/bifi22.003_gpmsll.jpg",

          `https://res.cloudinary.com/habitatsartorial/image/upload/v1659380200/2022/bifi22/bifi22.004_uoe7mg.jpg`,
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380200/2022/bifi22/bifi22.002_dc4dzj.jpg",

          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380199/2022/bifi22/bifi22.005_nepplv.jpg",
        ],
        description: [
          "Artist Logo Across Chest",
          "Color-Matched Show Poster Across Back",
          "100% 6oz American-Grown Supima cotton",
          "Preshrunk, soft-washed, garment-dyed",
          "Color: Black",
          "",
          "Half the profit from the sale of this item will go to the artist. The other half will be donated to charity.",
        ],
        name: "By Indy, For Indy Shortsleeve Tee",
        disabled: false,
      },

      {
        id: 23,
        price: 27,
        type: "LS Tee",
        img: `https://res.cloudinary.com/habitatsartorial/image/upload/${productsImageManip}/v1659380275/2022/bifi22/icons.002_rol8fp.jpg`,
        images: [
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380199/2022/bifi22/bifi22.003_gpmsll.jpg",

          `https://res.cloudinary.com/habitatsartorial/image/upload/v1659380200/2022/bifi22/bifi22.004_uoe7mg.jpg`,
          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380200/2022/bifi22/bifi22.002_dc4dzj.jpg",

          "https://res.cloudinary.com/habitatsartorial/image/upload/v1659380199/2022/bifi22/bifi22.005_nepplv.jpg",
        ],
        description: [
          "Artist Logo Across Chest",
          "Color-Matched Show Poster Across Back",
          "100% 6oz American-Grown Supima cotton",
          "Preshrunk, soft-washed, garment-dyed",
          "Color: Black",
          "",
          "Half the profit from the sale of this item will go to the artist. The other half will be donated to charity.",
        ],
        name: "By Indy, For Indy Longsleeve Tee",
        disabled: false,
      },
    ],
  },
];

export default artists;
